// Mock data for EDIFÍSICA website

export const heroData = {
  title: "Ingeniería Sustentable e Industrialización para la Construcción del Futuro",
  subtitle: "Desarrollamos soluciones técnicas avanzadas para edificaciones eficientes, industrializadas y ambientalmente responsables.",
  videoUrl: "https://images.unsplash.com/photo-1576577610667-c9ea0ac983fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxtb2R1bGFyJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3OTYxODA0OXww&ixlib=rb-4.1.0&q=85",
  ctaButtons: [
    { text: "Conocer Servicios", href: "#servicios" },
    { text: "Solicitar Evaluación Técnica", href: "#contacto" }
  ]
};

export const aboutData = {
  company: {
    name: "EDIFÍSICA SPA",
    description: "Empresa especializada en ingeniería aplicada, física de la construcción e industrialización de soluciones habitacionales, enfocada en el desarrollo de edificaciones eficientes, sustentables y técnicamente avanzadas.",
    mission: "Integramos innovación, eficiencia energética, comportamiento higrotérmico, desempeño acústico y acreditación normativa para proyectos públicos y privados.",
    focus: [
      "Eficiencia constructiva",
      "Sustentabilidad ambiental",
      "Calidad técnica",
      "Velocidad de ejecución",
      "Desempeño integral de las edificaciones"
    ]
  },
  professional: {
    name: "Ángel Navarrete",
    title: "Gerente General | Consultor Senior",
    specializations: [
      "Acústica",
      "Investigación, Desarrollo e Innovación (I+D+i)",
      "Diseño Energéticamente Eficiente",
      "Diseño Contra Incendios",
      "Hormigones de Alto Desempeño",
      "Planificación y Control de Proyectos",
      "Sustentabilidad en Edificación"
    ],
    expertise: [
      "Física de la construcción",
      "Industrialización habitacional",
      "Sistemas constructivos avanzados",
      "Eficiencia energética",
      "Innovación normativa"
    ],
    certifications: [
      "Termógrafo certificado",
      "Consultor técnico para proyectos industrializados",
      "Asesor en acreditación de viviendas tipo y sistemas constructivos",
      "Calificador Energético de Viviendas MINVU"
    ]
  }
};

export const industrializationData = {
  title: "Industrialización Aplicada a la Construcción",
  description: "EDIFÍSICA impulsa el desarrollo de sistemas constructivos industrializados orientados a:",
  benefits: [
    {
      title: "Optimización de Tiempos",
      description: "Reducción significativa en los plazos de ejecución de proyectos",
      icon: "clock"
    },
    {
      title: "Reducción de Residuos",
      description: "Minimización de residuos de obra mediante fabricación controlada",
      icon: "recycle"
    },
    {
      title: "Eficiencia Energética",
      description: "Mayor control térmico y desempeño energético superior",
      icon: "zap"
    },
    {
      title: "Control de Calidad",
      description: "Procesos estandarizados y certificados de fabricación",
      icon: "shield-check"
    },
    {
      title: "Costos Optimizados",
      description: "Disminución de costos operacionales y de construcción",
      icon: "trending-down"
    },
    {
      title: "Sustentabilidad",
      description: "Reducción de huella ambiental y emisiones",
      icon: "leaf"
    }
  ],
  systems: [
    "Vivienda Industrializada",
    "Sistemas SIP",
    "Construcción Modular",
    "Light Steel Framing",
    "Prefabricación Avanzada",
    "Certificación de Viviendas Tipo",
    "Desarrollo de Sistemas Constructivos"
  ],
  image: "https://images.unsplash.com/photo-1517011453931-c30f571a4fab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxtb2R1bGFyJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3OTYxODA4Mnww&ixlib=rb-4.1.0&q=85"
};

export const sustainabilityData = {
  title: "Construcción Sustentable y Compromiso Ambiental",
  description: "Promovemos soluciones constructivas orientadas a minimizar impactos ambientales y maximizar el desempeño energético de las edificaciones.",
  services: "Nuestros servicios incorporan eficiencia térmica, reducción de emisiones, optimización energética, análisis higrotérmico, materiales de alto desempeño, y estrategias de sustentabilidad aplicadas a proyectos habitacionales e industriales.",
  highlights: [
    {
      title: "Certificación Energética",
      description: "Evaluación y certificación del desempeño energético de edificaciones",
      icon: "award"
    },
    {
      title: "Viviendas Sustentables",
      description: "Diseño de viviendas con criterios ambientales y de eficiencia",
      icon: "home"
    },
    {
      title: "Reducción de Huella",
      description: "Minimización de huella de carbono en proyectos constructivos",
      icon: "trending-down"
    },
    {
      title: "Optimización Térmica",
      description: "Análisis y mejora del comportamiento térmico de edificios",
      icon: "thermometer"
    },
    {
      title: "Gestión de Recursos",
      description: "Uso eficiente de recursos naturales y energéticos",
      icon: "droplet"
    },
    {
      title: "Innovación Ambiental",
      description: "Desarrollo de soluciones constructivas ambientalmente responsables",
      icon: "lightbulb"
    }
  ],
  image: "https://images.unsplash.com/photo-1556983852-43bf21186b2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxzdXN0YWluYWJsZSUyMGJ1aWxkaW5nfGVufDB8fHx8MTc3OTYxODEwOXww&ixlib=rb-4.1.0&q=85"
};

export const servicesData = [
  {
    title: "Acreditación Normativa de Sistemas Constructivos",
    description: "Evaluación y certificación técnica de sistemas constructivos según normativa vigente",
    icon: "file-check"
  },
  {
    title: "Certificación de Viviendas Industrializadas",
    description: "Acreditación técnica de viviendas tipo y soluciones industrializadas",
    icon: "building"
  },
  {
    title: "Estudios de Eficiencia Energética",
    description: "Análisis detallado de comportamiento térmico y energético de edificaciones",
    icon: "battery-charging"
  },
  {
    title: "Certificación de Viviendas Sustentables",
    description: "Evaluación de criterios de sustentabilidad y certificación ambiental",
    icon: "leaf"
  },
  {
    title: "Estudios Acústicos",
    description: "Análisis de comportamiento acústico y aislación sonora de edificios",
    icon: "volume-2"
  },
  {
    title: "Comportamiento Frente al Fuego",
    description: "Evaluación de resistencia al fuego y seguridad de sistemas constructivos",
    icon: "flame"
  },
  {
    title: "Estudios Higrotérmicos",
    description: "Análisis de condensación, humedad y comportamiento higrotérmico",
    icon: "cloud-rain"
  },
  {
    title: "Claims Construction",
    description: "Peritajes y evaluación técnica de conflictos constructivos",
    icon: "gavel"
  },
  {
    title: "Comisionamiento Técnico",
    description: "Verificación y validación del desempeño de sistemas de edificios",
    icon: "check-circle"
  },
  {
    title: "Memorias de Cálculo Estructural",
    description: "Desarrollo de cálculos estructurales y diseño de elementos",
    icon: "calculator"
  },
  {
    title: "Investigación, Desarrollo e Innovación (I+D+i)",
    description: "Desarrollo de soluciones innovadoras y mejora de sistemas constructivos",
    icon: "beaker"
  },
  {
    title: "Estudios de Equivalencia Técnica",
    description: "Evaluación de equivalencias entre sistemas y soluciones constructivas",
    icon: "git-compare"
  },
  {
    title: "Completo Desarrollo Técnico",
    description: "Normativo, de proyectos inmobiliarios sociales y privados",
    icon: "layers"
  }
];

export const projectsData = [
  {
    title: "Vivienda Social Industrializada",
    description: "Desarrollo de soluciones habitacionales eficientes para programas sociales",
    image: "https://images.pexels.com/photos/29095697/pexels-photo-29095697.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Industrialización"
  },
  {
    title: "Certificación Energética Edificios",
    description: "Evaluación y certificación de desempeño energético en edificaciones comerciales",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBwcm9qZWN0fGVufDB8fHx8MTc3OTYxODEzNXww&ixlib=rb-4.1.0&q=85",
    category: "Sustentabilidad"
  },
  {
    title: "Sistemas Constructivos Innovadores",
    description: "Desarrollo y acreditación de nuevos sistemas constructivos industrializados",
    image: "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBwcm9qZWN0fGVufDB8fHx8MTc3OTYxODEzNXww&ixlib=rb-4.1.0&q=85",
    category: "Innovación"
  },
  {
    title: "Estudios Ambientales Complejos",
    description: "Análisis integral de comportamiento térmico, acústico y energético",
    image: "https://images.pexels.com/photos/18162494/pexels-photo-18162494.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    category: "Consultoría"
  }
];

export const innovationData = {
  title: "Innovación Técnica para Nuevos Modelos Constructivos",
  description: "EDIFÍSICA participa activamente en el desarrollo de nuevas soluciones constructivas y modelos de edificación orientados a:",
  areas: [
    "Industrialización",
    "Sustentabilidad",
    "Optimización de recursos",
    "Eficiencia energética",
    "Innovación normativa",
    "Desarrollo habitacional avanzado"
  ]
};

export const valuesData = [
  {
    title: "Innovación",
    description: "Desarrollo constante de soluciones técnicas avanzadas",
    icon: "lightbulb"
  },
  {
    title: "Sustentabilidad",
    description: "Compromiso con el medio ambiente y eficiencia energética",
    icon: "leaf"
  },
  {
    title: "Precisión Técnica",
    description: "Rigor y exactitud en cada desarrollo y análisis",
    icon: "target"
  },
  {
    title: "Compromiso Ambiental",
    description: "Responsabilidad con el impacto ambiental de nuestros proyectos",
    icon: "globe"
  },
  {
    title: "Excelencia Profesional",
    description: "Alta calidad y especialización en cada servicio",
    icon: "award"
  },
  {
    title: "Desarrollo Tecnológico",
    description: "Integración de tecnología en soluciones constructivas",
    icon: "cpu"
  }
];

export const contactData = {
  address: "Carlos Anwandter 630, piso 3, Valdivia",
  phone: "+56 9 8187 2772",
  email: "angel.navarrete.t@gmail.com",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3068.7489!2d-73.24589!3d-39.81403!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDQ4JzUwLjUiUyA3M8KwMTQnNDUuMiJX!5e0!3m2!1sen!2scl!4v1234567890"
};